import React from 'react'
import { CSSTransition } from 'react-transition-group'
import styles from './styles.module.scss'
import { ReactComponent as DialButtonIcon } from '../../images/dial-button.svg'
import { Button } from '@missionlabs/smartagent-app-components'

interface Props {
    isDialButtonShown: boolean
    onClick: (evt: React.MouseEvent) => void
}

const DialButton = ({ isDialButtonShown, onClick }: Props) => (
    <CSSTransition
        in={isDialButtonShown}
        timeout={200}
        mountOnEnter
        unmountOnExit
        classNames={{
            enter: styles['dialButton--enter'],
            enterActive:
                styles['dialButton--enter-active'],
            enterDone:
                styles['dialButton--enter-done'],
            exitActive:
                styles['dialButton--exit-active'],
            exitDone:
                styles['dialButton--exit-done'],
        }}
    >
        <Button
            onClick={onClick}
            className={styles.dialButton}
        >
            <DialButtonIcon />
        </Button>
    </CSSTransition>
)

export default DialButton
